import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { focus } from '@dojo/framework/core/middleware/focus';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Orientation, Tooltip } from '@dojo/widgets/tooltip';
import { createNlsMiddleware, userstate, lccstate } from '@holmescorp/lcc-state';
import { SlidingPane } from '@holmescorp/base-widgets';
import { PathChoice } from '@holmescorp/dashboard-widgets';
import { Icon } from '@holmescorp/base-widgets';
import { isEmpty } from 'lodash-es';
import css from '../css/dashbutton.m.css';
const factory = create({
    icache,
    nls: createNlsMiddleware('ditabook'),
    userstate,
    lccstate,
    focus,
    theme
});
export const Dashboard = factory(({ children, middleware: { icache, nls, userstate, lccstate, focus, theme } }) => {
    const { get, path } = userstate;
    const quizPattern = get(path('quizPattern'));
    const { get: lget, path: lpath } = lccstate;
    const quizpatterns = lget(lpath('quizpatterns'));
    const emptyQP = { '': '' };
    const hasQP = !isEmpty(quizpatterns) && JSON.stringify(quizpatterns) !== JSON.stringify(emptyQP);
    const { isPlaceholder, messages: { dashboard_button_tooltip = '[ditabook] dashboard_button_tooltip', dashboard_title = '[ditabook] dashboard_title' } } = nls();
    if (isPlaceholder) {
        return null;
    }
    const focusNode = icache.getOrSet('focusNode', 'trigger');
    const ttHover = () => {
        icache.set('ttopen', true);
    };
    const ttFocus = () => {
        focus.focus();
        icache.set('ttopen', true);
    };
    const ttHidden = () => icache.set('ttopen', false);
    const altText = dashboard_button_tooltip;
    const ttText = dashboard_button_tooltip;
    const faname = 'tachometer-alt';
    const xqa = 'dash-button';
    const { root } = theme.classes(css);
    const open = icache.getOrSet('open', false);
    const vw = window.innerWidth || 0;
    return v('div', { xqa, classes: [theme.variant(), root] }, [
        w(Tooltip, { open: icache.getOrSet('ttopen', false), orientation: Orientation.top }, [
            {
                content: ttText,
                trigger: v('button', {
                    key: 'trigger',
                    focus: () => focusNode === 'trigger' && focus.shouldFocus(),
                    onclick: () => {
                        icache.set('focusNode', 'dashboard');
                        icache.set('open', true);
                    },
                    onmouseover: ttHover,
                    onmouseout: ttHidden,
                    onfocus: ttFocus,
                    onblur: ttHidden
                }, [
                    w(Icon, {
                        size: '3x',
                        faname,
                        altText,
                        xqa
                    })
                ])
            }
        ]),
        open &&
            w(SlidingPane, {
                key: 'dashboard',
                xqa: 'dashboard-sliding-pane',
                open,
                align: 'right',
                underlay: true,
                title: dashboard_title,
                width: Math.min(vw, 1024),
                onRequestClose: () => {
                    icache.set('focusNode', 'trigger');
                    focus.focus();
                    icache.set('open', false);
                }
            }, [!hasQP || quizPattern ? v('div', {}, children()) : w(PathChoice, {})])
    ]);
});
export default Dashboard;
